import { lazy, Suspense, useContext } from "react";
import { Spinner } from "react-bootstrap";
import { Navigate, useLocation, useRoutes } from "react-router";

import { AppContext } from "./AppContext";
import ParticipantRegisterPage from "./Components/ParticipantRegister";

const HomePage = lazy(() =>
  import(/* webpackChunkName: "HomePage" */ `./Components/HomePage`)
);

const ParticipantHomePage = lazy(() =>
  import(
    /* webpackChunkName: "ParticipantHomePage" */ `./Components/ParticipantHomePage`
  )
);
const OrganizerHomePage = lazy(() =>
  import(
    /* webpackChunkName: "OrganizerHomePage" */ `./Components/OrganizerHomePage`
  )
);

const TopicDetailsPage = lazy(() =>
  import(
    /* webpackChunkName: "TopicDetailsPage" */ `./Components/TopicDetailsPage`
  )
);

const ParticipantRegistrationPage = lazy(() =>
  import(
    /* webpackChunkName: "ParticipantHomePage" */ `./Components/ParticipantRegistrationPage`
  )
);

const ParticipantSignInPage = lazy(() =>
  import(
    /* webpackChunkName: "ParticipantHomePage" */ `./Components/ParticipantSignInPage`
  )
);

const ParticipantSubmitPage = lazy(() =>
  import(
    /* webpackChunkName: "ParticipantSubmitPage" */ `./Components/ParticipantSubmit`
  )
);
const ParticipantProfilePage = lazy(() =>
  import(
    /* webpackChunkName: "ParticipantHomePage" */ `./Components/ParticipantProfilePage`
  )
);
const AddEditTopicsPage = lazy(() =>
  import(
    /* webpackChunkName: "AddEditTopicsPage" */ `./Components/AddEditTopicsPage`
  )
);

const PublishWinnersPage = lazy(() =>
  import(
    /* webpackChunkName: "PublishWinnersPage" */ `./Components/AddEditTopicsPage/PublishWinnersPage`
  )
);

const Dashboard = lazy(() =>
  import(/* webpackChunkName: "Dashboard" */ `./Components/Dashboard`)
);

const AdminPage = lazy(() =>
  import(/* webpackChunkName: "AdminPage" */ `./Components/AdminPage`)
);

const Layout = lazy(() =>
  import(/* webpackChunkName: "Layout" */ `./Components/Layout`)
);

const Error = lazy(() =>
  import(/* webpackChunkName: "Error" */ `./Components/Error`)
);

const AuthRoute = ({ to }) => {
  const [data] = useContext(AppContext);
  let location = useLocation();

  if (!data?.isLoggedIn) {
    sessionStorage.setItem("AfterloginRouteBackurl", location.pathname);
  }
  // return data?.isLoggedIn ? to : <Navigate to="/ParticipantSignInPage" />;
  return data?.isLoggedIn ? to : <Navigate to="/error" />;
};

const AdminAuthRoute = ({ to }) => {
  const [data] = useContext(AppContext);
  // return data?.isLoggedIn ? to : <Navigate to="/ParticipantSignInPage" />;
  return data?.userRoles?.includes("Admin") ? to : <Navigate to="/error" />;
};

const RoutesComponent = () => {
  const routesArray = [
    {
      path: "/",
      element: <Layout />,
      children: [
        { index: true, element: <Navigate to="/home" /> },
        {
          path: "/home",
          element: <HomePage />,
          // children: [ {
          //   path: '/home/participantHome',
          //   element: <ParticipantHomePage />,
          // },]
        },
        {
          path: "/participant-topics",
          element: <ParticipantHomePage />,
        },
        {
          path: "/participant-topics?filter=Filtername",
          element: <ParticipantHomePage />,
        },
        {
          path: "/organizer-topics",
          element: <OrganizerHomePage />,
        },
        {
          path: "/organizer-topics/Filter?filter=Filtername",
          element: <OrganizerHomePage />,

        },
        {
          path: "/participant-topic-detail/:id?",
          element: <TopicDetailsPage />,
        },
        {
          path: "/organizer-topic-detail/:id?",
          element: <AuthRoute to={<TopicDetailsPage />} />,
        },
        {
          path: "/participant-sign-up",
          element: <ParticipantRegistrationPage />,
        },
        {
          path: "/participant-sign-in",
          element: <ParticipantSignInPage />,
        },
        {
          path: "/participant-submit/:projectid",
          element: <ParticipantSubmitPage />,
          // element:<AuthRoute to={<participant-submit />} />
        },
        {
          path: "/participant-submit/:projectid/Update",
          element: <ParticipantSubmitPage />,
          // element:<AuthRoute to={<participant-submit />} />
        },
        {
          path: "/participant-register/:projectid",
          element: <ParticipantRegisterPage />,
          // element:<AuthRoute to={<participant-submit />} />
        },
        {
          path: "/profile",
          // element: <ParticipantProfilePage />,
          element: <AuthRoute to={<ParticipantProfilePage />} />,
        },
        // {
        //   path: "/OrganizerProfilePage",
        //   // element: <ParticipantProfilePage />,
        //   element:<AuthRoute to={<ParticipantProfilePage />} />
        // },
        {
          path: "/add-hackathon/:projectid?",
          element: <AddEditTopicsPage />,
        },
        {
          path: "/publish-winners/:sessionId",
          element: <AuthRoute to={<PublishWinnersPage />} />,
        },
        {
          path: "/edit-topic/:projectid?",
          element: <AddEditTopicsPage />,
        },
        {
          path: "/admin/*",
          element: <AdminAuthRoute to={<AdminPage />} />,
        },
        {
          path: "/dashboard",
          element: <Dashboard />,
        },
        {
          path: "/error",
          element: <Error />,
        },
        {
          path: "*",
          element: <Navigate replace to="/error" />,
        },
      ],
    },
  ];
  const routesElement = useRoutes(routesArray);

  return (
    <Suspense
      fallback={
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      }
    >
      {routesElement}
    </Suspense>
  );
};

export default RoutesComponent;
